export const validatePowerAd = (data) => {
  if (!data) {
    return false
  }
  if (!data.Title || !data.Title.length) {
    return false
  }
  if (!data.Url || !data.Url.length) {
    return false
  }
  if (!data.Price || isNaN(Number(data.Price))) {
    return false
  }
  return true
}

export const validateDNAAd = (data) => {
  if (!data) {
    return false
  }
  if (!data.product_name || !data.product_name.length) {
    return false
  }
  if (!data.product_deeplink || !data.product_deeplink.length) {
    return false
  }
  if (!data.product_price || !data.product_price.length) {
    return false
  }
  return true
}
